// authManager.js or in your main application component
// import store from './store';
// import { setAuthUser, setAccessToken } from './store';
// Import the functions you need from the Firebase SDKs
import { 
  getAuth, 
  onAuthStateChanged, 
  // getMultiFactorResolver, PhoneMultiFactorGenerator, PhoneAuthProvider, 
  OAuthProvider, 
  FacebookAuthProvider, 
  GoogleAuthProvider, 
  EmailAuthProvider, 
  signInWithPopup, 
  // RecaptchaVerifier, 
  signOut, 
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  sendEmailVerification
  // multiFactor 
} from 'firebase/auth';
import { initializeApp, FirebaseError } from 'firebase/app';
import { getFirestore, doc, setDoc } from "firebase/firestore";

class AuthManager {
  constructor() {
    this.store = require('./store');
    this.authPromise = null; // Holds the authentication promise
    this.authUser = null;
    // Your web app's Firebase configuration (you can get this from the Firebase console)
    const firebaseConfig = {
      apiKey: "AIzaSyDiIpvCoxELqcaU5WEFhNGLOYSzDvTLtt0",
      authDomain: "roflcopter-e921f.firebaseapp.com",
      projectId: "roflcopter-e921f",
      storageBucket: "roflcopter-e921f.appspot.com",
      messagingSenderId: "942046792304",
      appId: "1:942046792304:web:44fc91f5b37b3aa54942b5"
    };

    // Initialize Firebase
    this.app = initializeApp(firebaseConfig);
    this.auth = getAuth(this.app);
    this.auth.useDeviceLanguage();
    this.initializeAuthListener();
    this.setDoc = setDoc;
    this.doc = doc;
    this.signInWithEmailAndPassword = signInWithEmailAndPassword;
    this.createUserWithEmailAndPassword = createUserWithEmailAndPassword;
    this.db = getFirestore(this.app);
    this.updateProfile = updateProfile;
    this.sendEmailVerification = sendEmailVerification;
  }
  
  getSignInWithPopup() {
    return signInWithPopup;
  }

  getAuthProvider(provider) {
    switch (provider) {
      case 'GoogleAuthProvider':
        return new GoogleAuthProvider();
        break;
      case 'FacebookAuthProvider':
        return new FacebookAuthProvider();
        break;
      case 'AppleAuthProvider':
        return new OAuthProvider('apple.com');
        break;
    }
  }

  getAuth() {
    return this.auth;
  }

  logOff() {
    return signOut(this.auth);
  }

  initializeAuthListener() {
    this.authPromise = new Promise(((resolve) => {
      onAuthStateChanged(this.auth, (user) => {
        if (user) {
          this.authUser = user;
          this.store.default.dispatch(this.store.setAccessToken(user.accessToken));
          resolve();
        } else {
          this.authUser = null;
          this.store.default.dispatch(this.store.setAccessToken(null));
          this.store.default.dispatch(this.store.setUser(null));
          resolve();
        }
      });
    }).bind(this));
  }

  async refreshUserToken() {
    try {
      if (!this.authUser) {
        console.error("No user to refresh token");
        return;
      }
      const token = await this.authUser.getIdToken(true);
      console.log("Token refreshed:", token);
      this.store.default.dispatch(this.store.setAccessToken(token));
      localStorage.setItem("token", token);
    } catch (error) {
      console.error("Error refreshing token:", error);
    }
  }
}

// Create a single instance of AuthManager
const authManager = new AuthManager();

export default authManager; // Export the instance